import { Injectable } from '@angular/core';
import { JwtTokenService } from './jwt-token.service';

@Injectable()
export class StorageService {
  private readonly tokenKey = 'brs-token';
  private readonly xsrfKey = 'XSRF-TOKEN';
  user = null;
  constructor( public jwtService: JwtTokenService ) { }

  setToken(token: any) {
    localStorage.setItem(this.tokenKey, token);
  }

  getToken() {
    return localStorage.getItem(this.tokenKey);
  }

  removeToken() {
    localStorage.removeItem(this.tokenKey);
  }

  setXsrf(token: any) {
    localStorage.setItem(this.xsrfKey, token);
  }

  getXsrf() {
    return localStorage.getItem(this.xsrfKey);
  }

  removeXsrf() {
    localStorage.removeItem(this.xsrfKey);
  }

  getUser() {
    return this.jwtService.getTokenData(this.getToken());
  }
  setUser(user: any) {
     this.user = user;
  }

  saveObject(name: any, obj: any) {
    localStorage.setItem(`${this.getUser().userId}_${name}`, JSON.stringify(obj));
  }

  getObject(name: any) {
    const item = localStorage.getItem(`${this.getUser().userId}_${name}`);
    return item ? JSON.parse(item) : null;
  }

  cleanObject(name: any) {
    return localStorage.removeItem(`${this.getUser().userId}_${name}`);
  }

  cleanStorage() {
    localStorage.clear();
  }
}
